<ng-container *transloco="let tr; scope 'profile'; prefix: 'profile'">
  <nz-page-header class="site-page-header" nzBackIcon (nzBack)="onBackClicked()">
    <nz-page-header-title>{{tr('passwordChange.title')}}</nz-page-header-title>
  </nz-page-header>
  <form nz-form [formGroup]="form" [nzLayout]="'horizontal'" (ngSubmit)="savePassword()">
    <nz-alert class="mb-1" [nzType]="'info'" [nzDescription]="tr('password.description')" nzShowIcon></nz-alert>

    <nz-form-item>
      <nz-form-label nzRequired [nzXs]="8">{{tr('form.password')}}</nz-form-label>
      <nz-form-control>
        <input nz-input formControlName="password"/>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label nzRequired [nzXs]="8">{{tr('form.passwordConfirmation')}}</nz-form-label>
      <nz-form-control>
        <input nz-input formControlName="passwordConfirmation"/>
      </nz-form-control>
    </nz-form-item>

    <nz-alert *ngFor="let kv of errorMessageMap | keyvalue"
              class="mb-1"
              [nzMessage]="kv.value"
              [nzType]="'error'" nzShowIcon></nz-alert>

    <nz-form-item>
      <nz-form-control [nzOffset]="8">
        <button [nzLoading]="isLoading.save" nz-button nzType="primary">{{'button.save' | transloco}}</button>
      </nz-form-control>
    </nz-form-item>
  </form>
</ng-container>
